import useHandleVeevaStatus from "@src/custom-hooks/use-handle-veeva-status";

import { useSession } from "next-auth/client"

import VeevaBody from "@components/common/veeva/body";

import Header from "../layout/header";
import Footer from "../Footer";
import DropdownPanelDesktop from "../menu/dropdownPanelDesktop";
import DropdownPanelMobile from "../menu/dropdownPanelMobile";
import LogoutButton from "../auth/logoutButton";
import Zendesk from "react-zendesk";

import { useRouter } from "next/router";

import type { LiveEvent, User } from "@src/types/index.interface";

import type { PropsWithChildren } from "react";

type CProps = {
  liveEvents: LiveEvent[];
  userData: User | null;
  hideFooter?: boolean;
  showPrescribingLink: boolean | null;
  chat?: any;
};

const MainLayoutComponent = (props: PropsWithChildren<CProps>) => {
  const { userVeevaStatus } = useHandleVeevaStatus();

  const [session] = useSession();

  const router = useRouter();

  return (
    <>

          {userVeevaStatus === "rejected" && session?.user.image.role === 5 ? (
            <VeevaBody
              title="Thank you for registering on Boehringer Click!"
              texts={[
                "We have received your request and are pleased by your interest.",
                "We are currently validating the information you provided and will confirm with you once the process is complete.",
              ]}
            />
          ) : null}

      {userVeevaStatus || !session ? (
        <>
          {userVeevaStatus === "approved" ||
          !session ||
          session?.user.image.role === 5 ? (
            <>
             <Zendesk
              zendeskKey={process.env.NEXT_PUBLIC_ZENDESK_KEY}
                webWidget={{
                  setLocale: "en",
                  zIndex: 19,
                }}
                onLoaded={() => console.log("Zendesk is loaded")}
              />
             
              <div className="font-boehringer_forward_head">
                {session && (
                  <Header session={session} liveEvents={props.liveEvents}>
                    <DropdownPanelDesktop
                      key="DropdownPanelDesktop"
                      showPrescribingLink={props.showPrescribingLink}
                      session={session}
                    >
                      <LogoutButton session={session} chat={props.chat} />
                    </DropdownPanelDesktop>

                    <DropdownPanelMobile
                      key="DropdownPanelMobile"
                      showPrescribingLink={props.showPrescribingLink}
                      session={session}
                    >
                      <LogoutButton session={session} />
                    </DropdownPanelMobile>
                  </Header>
                )}

                {session && props.userData && (
                  <div
                    className="hidden instatag-login"
                    data-it-logged-in="true"
                    data-it-auth-method="email"
                    data-it-visitor-type={`HCP ${props.userData?.specialty?.name}`}
                    data-it-uid={`${props.userData?.id}`}
                    data-it-uid-type="UserID"
                  >
                    User Successfully Logged In
                  </div>
                )}

                <div
                  className={`bg-gray-100 antialiased overflow-x-hidden ${
                    session ? "mt-16 md:mt-28" : ""
                  }`}
                  style={{
                    backgroundImage: router.pathname.includes("/casos/[slug]")
                      ? "url(/img/bg-cases.jpg)"
                      : "none",
                  }}
                >
                  {props.children}
                </div>

                {!props.hideFooter && <Footer />}
              </div>
            </>
          ) : null}

          {userVeevaStatus === "pending" && session?.user.image.role !== 5 ? (
            <VeevaBody
              title="We are validating your information!"
              texts={[
                "We have received your registration to browse the Boehringer Click site.",
                "We are currently validating your information and will notify you once we have verified your details.",
              ]}
            />
          ) : null}

          {userVeevaStatus === "rejected" && session?.user.image.role !== 5 ? (
            <VeevaBody
              title="Thank you for your interest in the Boehringer Click site!"
              texts={[
                "We were unable to verify that you are a healthcare professional.",
                "Please verify that your information is correct.",
                "If you believe there is an error, please contact us at: <br /> <a class='text-bi-green-malachite-500' href='mailto:soporte.mex@boehringer-ingelheim.com'>soporte.mex@boehringer-ingelheim.com</a>",
              ]}
            />
          ) : null}

        </>
      ) : null}
    </>
  );
};

export default MainLayoutComponent;
